import React from "react";
import { motion } from "framer-motion";


const LetsGet = () => {

 const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

  return (
    <div className="relative w-[96%] lg:w-[95%] mx-auto bg-gradient-to-r from-[#F56E0F]/30 to-[#F56E0F]/50 py-16 px-4 sm:px-6 xl:px-12 lg:px-5 overflow-hidden rounded-3xl min-h-[300px] md:min-h-auto mb-14">
      <div className="absolute top-1/2 left-0 -translate-y-1/2 -translate-x-1/2 w-[400px] h-[400px] bg-orange-600 rounded-full blur-3xl opacity-50 hidden md:block"></div>

      <div className="hidden lg:block absolute bottom-0 left-10 lg:left-14 w-24 lg:w-auto">
        <img
          src="/assets/OpenLogo.png"
          alt="Decorative"
          className="w-[500px] h-full object-contain opacity-60 brightness-50"
        />
      </div>

      <div className="flex flex-col lg:flex-row items-center justify-between gap-x-16">
        {/* <div className="text-left z-10"> */}
        <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="text-left z-10"
          >
          <p className="bodyFont text-xl lg:text-2xl font-semibold leading-snug tracking-wide text-white text-left">
            Let’s Make Your Brand the One <br /> Everyone’s Talking About
          </p>
          </motion.div>
        {/* </div> */}

        {/* <div className="mt-8 lg:mt-0 z-10 flex justify-center w-full lg:w-auto">
          <div
            className="p-4 sm:p-5 md:p-6 w-[300px] sm:w-[320px] md:w-[350px] lg:w-[450px] xl:w-[550px]
                       h-[160px] sm:h-[200px] md:h-[200px] lg:h-[180px]
                       bg-white/50 backdrop-blur-md rounded-3xl shadow-lg border border-white/30"
          >
            <div className="p-4 sm:p-6 md:p-8 w-full h-full bg-white backdrop-blur-md rounded-3xl shadow-lg border border-white/20 flex items-center justify-center">
              <div className="flex justify-center mt-[5%] lg:mt-[2%]">
                <div className="joint_btn arrow_btn-wrapper bg-[#F56E0F] w-36 h-10 rounded-full cursor-pointer flex items-center justify-center text-white">
                  Let’s Get Building
                </div>

                <div style={{ "--clr": "#F56E0F" }} className="arrow_btn cursor-pointer">
                  <span className="arrow_btn__icon-wrapper_white bg-red-100">
                    <svg
                      width="10"
                      className="arrow_btn__icon-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 14 15"
                    >
                      <path
                        fill="currentColor"
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      />
                    </svg>

                    <svg
                      className="arrow_btn__icon-svg arrow_btn__icon-svg--copy"
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      fill="none"
                      viewBox="0 0 14 15"
                    >
                      <path
                        fill="currentColor"
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="mt-8 lg:mt-0 z-10 flex justify-center w-full lg:w-auto"
          >
            <div
              className="p-4 sm:p-5 md:p-6 w-[300px] sm:w-[320px] md:w-[350px] lg:w-[450px] xl:w-[550px]
                        h-[160px] sm:h-[200px] md:h-[200px] lg:h-[180px]
                        bg-white/50 backdrop-blur-md rounded-3xl shadow-lg border border-white/30"
            >
              <div className="p-4 sm:p-6 md:p-8 w-full h-full bg-white backdrop-blur-md rounded-3xl shadow-lg border border-white/20 flex items-center justify-center">
                <div className="flex justify-center mt-[5%] lg:mt-[2%]">
                  <div className="joint_btn arrow_btn-wrapper bg-[#F56E0F] w-40 h-8 rounded-full cursor-pointer flex items-center justify-center text-white">
                    Let’s Get Building
                  </div>

                  <div style={{ "--clr": "#F56E0F" }} className="arrow_btn cursor-pointer">
                  <span className="arrow_btn__icon-wrapper_white bg-red-100">
                    <svg
                      width="10"
                      className="arrow_btn__icon-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 14 15"
                    >
                      <path
                        fill="currentColor"
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      />
                    </svg>

                    <svg
                      className="arrow_btn__icon-svg arrow_btn__icon-svg--copy"
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      fill="none"
                      viewBox="0 0 14 15"
                    >
                      <path
                        fill="currentColor"
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      />
                    </svg>
                  </span>
                </div>
                </div>
              </div>
            </div>
          </motion.div>


      </div>
    </div>
  );
};

export default LetsGet;